import React from 'react';
import { BaasicInput, Loader, BaasicCheckbox, BaasicDropdown } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';

function ReturnAddressEditTemplate({ returnAddressEditViewStore, t }) {
	const {
		form,
		loading,
		stateDropdownStore,
		countryDropdownStore,
		onCheck,
		isSuperAdmin,
		isEdit,
		sellerDropdownStore,
	} = returnAddressEditViewStore;
	if (loading) return <Loader />;
	return (
		<React.Fragment>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('RETURNADDRESS')}</h3>
				</div>
				<div className="ReactModal__body">
					<div className="spc--bottom--sml">
						{isSuperAdmin && !isEdit && (
							<BaasicDropdown
								dropdownStore={sellerDropdownStore}
								placeholder={t('PLACEHOLDER.SELLER')}
								className="w--200--px spc--right--sml"
								isDisabled={isEdit}
							/>
						)}
					</div>
					<React.Fragment>
						<BaasicInput field={form.$('name')} />
					</React.Fragment>
					<React.Fragment>
						<BaasicInput field={form.$('address.address1')} />
					</React.Fragment>
					<React.Fragment>
						<BaasicInput field={form.$('address.address2')} />
					</React.Fragment>
					<React.Fragment>
						<BaasicInput field={form.$('address.address3')} />
					</React.Fragment>
					<React.Fragment>
						<BaasicInput field={form.$('address.city')} />
					</React.Fragment>
					<React.Fragment>
						<BaasicDropdown dropdownStore={stateDropdownStore} isClearable={true} className="spc--bottom--sml" />
					</React.Fragment>
					<React.Fragment>
						<BaasicInput field={form.$('address.zipCode')} />
					</React.Fragment>
					<React.Fragment>
						<BaasicDropdown dropdownStore={countryDropdownStore} isClearable={true} className="spc--bottom--sml" />
					</React.Fragment>
					<React.Fragment>
						<BaasicCheckbox
							id={form.$('name')}
							onChange={onCheck}
							label="RETURNADDRESSFORM.ISDEFAULTRETURNADDRESS"
							checked={form.$('isDefaultReturnAddress').value}
						/>
					</React.Fragment>
				</div>
				<div className="ReactModal__footer">
					<button
						className="btn btn--med btn--primary spc--bottom--sml"
						type="submit"
						disabled={loading}
						data-cy="save-button"
					>
						{loading ? (
							<div className="spinnercont spc--right--sml">
								<div className="spinner"></div>
							</div>
						) : null}
						{t('SAVE')}
					</button>
				</div>
			</form>
		</React.Fragment>
	);
}

export default defaultTemplate(ReturnAddressEditTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/return-address/pages/ReturnAddressEditTemplate.jsx